import './styles/index.scss';
import PopperJs from 'popper.js';
import jquery from 'jquery';
import bootstrap from 'bootstrap';

window.onload = function() {
    console.log(jquery);
    jquery('#lifco').modal('show');
}
